import { transformConsignmentWeightValue } from '@/utils/pages/Production/consignment/transform'
import { toNum } from '@/utils/string'

// Собираем массив строк для модального окна, если общий вес уже был сохранен
export function mappedDirtyWeights (data) {
  return data?.map(item => ({
    id: item.id,
    material_document_id: item?.material_document_id || null,
    length: item?.material_document?.warehouse_material?.length || null,
    warehouse_material: item?.material_document?.warehouse_material || null,
    count: item?.count || null,
    reserved_count: item?.material_document?.count || null,
    amount: item?.material_document?.amount || null,
    weight_dirty: item?.weight_dirty || null
  }))
}

// Собираем массив строк для модального окна, если общий вес ещё не был сохранен
export function mappedReserveData (data) {
  return data?.map(item => ({
    id: null,
    material_document_id: item.id || null,
    length: item?.warehouse_material?.length || null,
    warehouse_material: item?.warehouse_material || null,
    count: null,
    reserved_count: item?.count || null,
    amount: item?.amount || null,
    weight_dirty: null
  }))
}

// Собираем params для отправки запроса на добавление веса по длине
export function mappedParamsWeightWithLength (data, setId = true) {
  const result = []
  data.forEach(item => {
    const pushedData = {
      weight_dirty: transformConsignmentWeightValue(item.weight_dirty),
      count: toNum(item.count),
      material_document_id: item.material_document_id || null
    }
    if (setId && item.id) pushedData.id = item.id
    result.push(pushedData)
  })

  return result
}
